export default __webpack_public_path__ + "static/media/Machine_1.7bd25fec.png";